import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../app/SliceUtils";

export const fetchEmployees = createAsyncThunk(
    '/api/employeeRoles/employees/isActive',
    (isActive, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employeeRoles/employees/${isActive}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const putEmployee = createAsyncThunk(
    '/api/employeeRoles/put',
    (updatedEmployee, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employeeRoles`, method: 'PUT', body: updatedEmployee }, rejectWithValue)
);

export const fetchEmployeeSchoolclasses = createAsyncThunk(
    '/api/employee/schoolclasses',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employee/schoolclasses`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchEmployeeAttendances = createAsyncThunk(
    '/api/employee/attendances',
    (departmentId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: (departmentId !== null) ?
                `api/employee/attendances/${departmentId}` :
                `api/employee/attendances`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const fetchTestUsersForLink = createAsyncThunk(
    '/api/employeeRoles/testusers',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employeeRoles/testusers`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const putLinkUsers = createAsyncThunk(
    '/api/employeeRoles/link',
    (usersToLink, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employeeRoles/link`, method: 'PUT', body: usersToLink }, rejectWithValue)
);

export const putUnlinkUsers = createAsyncThunk(
    '/api/employeeRoles/unlink/userId',
    (userId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/employeeRoles/unlink/${userId}`, method: 'PUT', contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const putStudentEmail = createAsyncThunk(
    '/api/student/updateStudentEmail',
    (studentEmail, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/student/updateStudentEmail`, method: 'PUT', body: studentEmail }, rejectWithValue)
);

export const employeeSlice = createSlice({
    name: "employee",
    initialState: {
        employee: null,
        employees: { data: null, status: null },
        employeeUpdate: { data: null, status: null },
        employeeSchoolclasses: { data: null, status: null },
        employeeAttendances: { data: null, status: null },
        testUsers: { data: null, status: null },
        linkUsers: { data: null, status: null },
        unlinkUsers: { data: null, status: null },
        studentEmailUpdate: { data: null, status: null },
    },
    reducers: {
        selectEmployee: (state, action) => {
            state.employee = action.payload;
        },
        resetEmployeeStatus: (state) => {
            ResetSliceState(state, ['employeeUpdate', 'linkUsers', 'unlinkUsers']);
        }
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchEmployees, 'employees');
        CreateAsyncStatusHandler(builder, putEmployee, 'employeeUpdate');
        CreateAsyncStatusHandler(builder, fetchEmployeeSchoolclasses, 'employeeSchoolclasses');
        CreateAsyncStatusHandler(builder, fetchEmployeeAttendances, 'employeeAttendances');
        CreateAsyncStatusHandler(builder, fetchTestUsersForLink, 'testUsers');
        CreateAsyncStatusHandler(builder, putLinkUsers, 'linkUsers');
        CreateAsyncStatusHandler(builder, putUnlinkUsers, 'linkUsers');
        CreateAsyncStatusHandler(builder, putStudentEmail, 'studentEmailUpdate');
    },
});

export const { selectEmployee, resetEmployeeStatus } = employeeSlice.actions;

export default employeeSlice.reducer;
